import { Grid, List } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { WordsDiff } from "@/components/WordsDiff";

import { PhysicalExamDiffColumn } from "../types/physical-exams";

const PhysicalExamsDiffColumn = ({
  columnName,
  sectionDetails,
  otherSectionDetails,
  noteDetails,
  otherNoteDetails,
  isPrevious,
  showRemoved = false,
  notesType = false,
}: PhysicalExamDiffColumn) => (
  // eslint-disable-next-line quilted/require-responsive-grid -- the previous and amended values sit side by side at every width, since comparing them is the point, and each half stays readable at 375px
  <Grid.Col span={6}>
    <TextWrapper pb={8} c="dimmed">
      {columnName}
    </TextWrapper>
    {notesType ? (
      <WordsDiff
        showRemoved={showRemoved}
        current={isPrevious ? otherNoteDetails : noteDetails}
        previous={isPrevious ? noteDetails : otherNoteDetails}
      />
    ) : (
      <List my={4} mx={16}>
        {sectionDetails?.map((detail, i) => (
          <List.Item key={`title-${i}`}>
            <WordsDiff
              showRemoved={showRemoved}
              current={isPrevious ? otherSectionDetails?.[i] : detail}
              previous={isPrevious ? detail : otherSectionDetails?.[i]}
            />
          </List.Item>
        )) || []}
      </List>
    )}
  </Grid.Col>
);

export default PhysicalExamsDiffColumn;
